import { BaseApiManager } from "../util/baseApiManager";

export class SupportApiManager extends BaseApiManager {
    constructor() {
        super('/support')
    }

    getDistricts = async () => {
        try {
            const response = await this.customAxios.get(`/districts`)
            
            return response.data
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    createDistrict = async (districtInfo) => {
        try {
            await this.customAxios.post(`/districts`, {...districtInfo}, {showLoader: true})
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    getSchoolsForDistrict = async (districtCode) => {
        try {
            const response = await this.customAxios.get(`/districts/${districtCode}/schools`)
            return response.data
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    addSchool = async (districtCode, school) => {
        try {
            await this.customAxios.post(`/districts/${districtCode}/schools`, {schoolName: school}, {showLoader: true})
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    removeSchoolFromDistrict = async (districtCode, school) => {
        try {
            await this.customAxios.delete(`/districts/${districtCode}/schools`, {
                params: {
                    schoolName: school,
                },
                showLoader: true
            })
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    getUsers = async (districtCode) => {
        try {
            const response = await this.customAxios.get(`/users/${districtCode}`)
            return response.data.users
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    createAdminUser = async (firstName, lastName, email, userDomain, districtCode) => {
        try {
            await this.customAxios.post(`/users/${districtCode}`, {
                firstName,
                lastName,
                email,
                userDomain,
            }, {showLoader: true})
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    deleteAdminUser = async (email, districtCode) => {
        try {
            await this.customAxios.delete(`/users/${districtCode}`, {
                params: {
                    email,
                },
                showLoader: true
            })
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }
}